'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateHeight = function calculateHeight(el) {
  // Source adapted from: http://youmightnotneedjquery.com/#outer_height_with_margin
  var height = el.offsetHeight;

  var _getComputedStyle = getComputedStyle(el);

  var marginTop = _getComputedStyle.marginTop;
  var marginBottom = _getComputedStyle.marginBottom;


  height += parseInt(marginTop, 10) + parseInt(marginBottom, 10);
  return height;
};

// Source adapted from: http://stackoverflow.com/a/16324762
var makeHandler = function makeHandler(el) {
  return function (event) {
    var scrollTop = el.scrollTop;
    var scrollHeight = el.scrollHeight;
    var type = event.type;
    var detail = event.detail;
    var wheelDelta = event.wheelDelta;

    var height = calculateHeight(el);
    var delta = type === 'DOMMouseScroll' ? detail * -40 : wheelDelta;
    var up = delta > 0;

    var prevent = function prevent() {
      event.stopPropagation();
      event.preventDefault();
      event.returnValue = false;

      return false;
    };

    if (!up && -delta > scrollHeight - height - scrollTop) {
      el.scrollTop = scrollHeight;
      return prevent();
    } else if (up && delta > scrollTop) {
      el.scrollTop = 0;
      return prevent();
    }
  };
};

exports.default = function (el) {
  var handler = makeHandler(el);

  var addEvent = (el.addEventListener || el.attachEvent).bind(el);
  var removeEvent = (el.removeEventListener || el.detachEvent).bind(el);

  addEvent('mousewheel', handler);
  addEvent('DOMMouseScroll', handler);

  return function () {
    removeEvent('mousewheel', handler);
    removeEvent('DOMMouseScroll', handler);
  };
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/isolated-scroll/lib/index.js
 ** module id = 691
 ** module chunks = 0
 **/